import loadImage from "./loadImage";

export default loadImage;
